export const createNavigationUrl = (path: string) => {
    return "/_/" + path;
};

export const processUrn = (urn: string) => {
    return urn + "://";
};
